import React, { FunctionComponent } from 'react'
import Top from './hero'
import SpecialOffers from './specialOffer'
import Sdg from './sdg'
import Apps from './apps'
import HomeBottomNav from '@/components/page/homeBottomNav'
import Handsets from './handsets'
import HelpSection from './help'
import Loader from '@/components/ui/loader'
import { useContentContext } from '@/context/ContentContext'
// import InstallPrompt from '@/components/ui/installPrompt'
// import { useGetAppContext } from '@/context/GetAppContext'

const Home: FunctionComponent = () => {
  const { state: { homePageContent } } = useContentContext()
  // const { show } = useGetAppContext()
  if (homePageContent === undefined) {
    return <div style={{ height: '80vh' }} className='flex items-center justify-center w-full'><Loader /></div>
  }
  return (
    <div>
      <Top banners={homePageContent.homeBanners} />
      <SpecialOffers specialOffers={homePageContent.specialOffers} />
      <Handsets shopItems={homePageContent.shopItems} />
      <HelpSection helps={homePageContent.helps} />
      <Sdg data={homePageContent.sdgs} />
      <Apps apps={homePageContent.apps} />
      <HomeBottomNav />
      {/* {show && <InstallPrompt />} */}
    </div>
  )
}
export default Home
